export interface IParticipant {
  participantId: number;
  name: string;
  gender: string;
  dob: string;
  role: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  phone?: string;
  email?: string;
}

export interface IBenefit {
  benefitId: number;
  participantName: string;
  productName: string;
  benefitName: string;
  amount: number | string;
  effectiveDate: string;
  paidToDate: string;
  termDate: string;
  monthlyAmount: number;
}

export interface IClient {
  clientId: number;
  clientName: string;
  packageName: string;
  totalMonthly: number;
  state: string;
  statusType: string;
  agentName: string;
  agentNPN: string;
  memberId: string;
  participants: IParticipant[];
  benefits: IBenefit[];
}
